export const MODULE_ENUM = {
    PICTURE: 'picture',
    PHONE: 'phone',
    CODE: 'code'
} as const;

export type LoginModuleType = (typeof MODULE_ENUM)[keyof typeof MODULE_ENUM];
